import "./button.css";
function ButtonOnly({ btnValue, btnClass, onFinish }) {
  return (
    <button className={btnClass} onClick={onFinish}>
      {btnValue}
    </button>
  );
}
export default ButtonOnly;
